import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { Flex } from '@chakra-ui/react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import { FiAlertCircle } from 'react-icons/fi';

import { Container, Error } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  containerStyle?: {};
}

const InputDate: React.FC<InputProps> = ({
  name,
  icon: Icon,
  containerStyle,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
	const iconRef = useRef<any>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isField, setIsField] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);
	const [isEmpt, setIsEmpt] = useState(false);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsField(!!inputRef.current?.value);
  }, []);

	const handleChange = useCallback(() => {
		if (
			!inputRef.current?.value ||
			inputRef.current?.value === undefined ||
			inputRef.current?.value === null ||
			inputRef.current?.value === ''
		) {
			setIsEmpt(true);
		} else {
			setIsEmpt(false);
		}
	}, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });

		if (
			!inputRef.current?.value ||
			inputRef.current?.value === undefined ||
			inputRef.current?.value === null ||
			inputRef.current?.value === ''
		) {
			setIsEmpt(true);
		} else {
			setIsEmpt(false);
		}
	}, [fieldName, registerField]);

  return (
    <Container
      isErrored={!!error}
      isField={isField}
      isFocused={isFocused}
      style={containerStyle}
    >
      {Icon && <Icon size={20} />}
      <input
        type="date"
				className={!isEmpt ? 'date-input--has-value' : ''}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
				onChange={handleChange}
				// onChange={(e: any) => setIsEmpt(e.target.value)}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      />

      {error && (
				<Error title={error}>
					<Flex pr={1} ref={iconRef}>
						<FiAlertCircle color="#c53030" size={20} />
					</Flex>
				</Error>
      )}
    </Container>
  );
};

export default InputDate;
